import { HeroSection } from "./sections/HeroSection";
import { ClientsSection } from "./sections/ClientsSection";
import { TeamSection } from "./sections/TeamSection";
import { BusinessInteligenceSection } from "./sections/BusinessInteligenceSection";
import { SmartChoices } from "./sections/SmartChoices";
import { CustomerIntelligenceSection } from "./sections/CustomerIntelligenceSection";
import { CardsSection } from "./sections/CardsSection";
// import { MagiaSection } from "./sections/MagiaSection";
// import { BlogSection } from "./sections/BlogSection";

export const Content = () => {
  return (
    <>
      <HeroSection />
      <div className="top-section-background">
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
          className="background-dots"
          style={{ top: "-20%", objectFit: "fill" }}
          alt="background"
        />
        <ClientsSection />
        <TeamSection />
      </div>
      <BusinessInteligenceSection />

      <SmartChoices />
      <div className="top-section-background" style={{ marginBottom: "8rem" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
          className="background-dots"
          alt="background"
        />
        <CustomerIntelligenceSection />
        <CardsSection />
        {/* <MagiaSection /> */}
      </div>
      {/* <BlogSection /> */}
    </>
  );
};
